import { Component } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { MatDialogRef } from '@angular/material/dialog';
import { DateTime } from 'luxon';
import { SessionTimeoutService } from '../../core/services/session-timeout.service';
import { SessionTimeoutState } from '../../core/enums/SessionTimeoutState';


@Component({
  selector: 'app-session-timeout-dialog',
  templateUrl: './session-timeout-dialog.component.html',
  styleUrl: './session-timeout-dialog.component.scss'
})
export class SessionTimeoutDialogComponent {
  
  private readonly countdownMax = 60;
  secondsToExpire: number = 60;
  loggingOut: boolean = false;
  timeoutInterval! : ReturnType<typeof setTimeout>;

  constructor(private readonly dialogRef: MatDialogRef<SessionTimeoutDialogComponent>,
              private authService : AuthService,
              private sessionTimeoutService : SessionTimeoutService) {}

  ngOnInit() {
    
      // Get the number of seconds before the session expires
      // Cap at 60 seconds, in case we throw this warning early for whatever reason
      const expires = this.authService.expires;
      if (expires == null) {
        this.secondsToExpire = 0;
      }
      else{
        const expiresDateTime = DateTime.fromISO(expires);
        this.secondsToExpire = Math.trunc(Math.min(expiresDateTime.diffNow('seconds').seconds, this.countdownMax));
      }


    // tick down the seconds
    this.timeoutInterval = setInterval(() => {
      this.secondsToExpire--;
      this.handleSessionState();
    }, 1000);
    
    this.dialogRef.beforeClosed().subscribe(() => {
      this.handleClose();
    });

  }

  /**
   * Check the session state
   * If the expiry is now fine, exit the dialog early
   * If it has already expired, log the user out (should only occur if user logs out in another tab, etc.)
   * Otherwise continue with the countdown
   */
  handleSessionState() {
    
    // Will be caught again during HandleClose to prevent re-refreshing the token
    const sessionState = this.sessionTimeoutService.getSessionState();
    if(sessionState == SessionTimeoutState.Fine) {
      this.dialogRef.close();
      return;
    }
    
    if(sessionState == SessionTimeoutState.Expired) {
      this.handleLogout();
      return;
    }

    if(this.secondsToExpire <= 0) {
      this.handleLogout();
      return;
    }    

  }

  handleLogout() {
    this.loggingOut = true;
    this.authService.logOut();
    this.dialogRef.close();
  }



  handleClose() {
    
    clearInterval(this.timeoutInterval);
    
    // In case multiple tabs are open, check if we still need to refresh the token
    const sessionState = this.sessionTimeoutService.getSessionState();
    if(sessionState == SessionTimeoutState.Fine)
      return;

    if(this.loggingOut) {
      return;
    }

    this.authService.RefreshToken().subscribe();
  }

}
